var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "smile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1--Onboarding---emoji",
    transform: "translate(-691.000000, -530.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(346.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(233.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smile",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.5,
    cy: 28.5,
    r: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,2.66453526e-15 C12.9837423,1.33226763e-15 2.22044605e-15,12.9837423 0,29 C-2.22044605e-15,45.0162577 12.9837423,58 29,58 C45.0162577,58 58,45.0162577 58,29 C57.9823641,12.991053 45.008947,0.0176358707 29,2.66453526e-15 Z M13,26.5 C13,24.5670034 14.5670034,23 16.5,23 C18.4329966,23 20,24.5670034 20,26.5 C20,28.4329966 18.4329966,30 16.5,30 C14.5670034,30 13,28.4329966 13,26.5 Z M40.26,39.5 C37.9382108,43.5238442 33.645646,46.002893 29,46.002893 C24.354354,46.002893 20.0617892,43.5238442 17.74,39.5 C17.5482512,39.1900585 17.54031,38.8003407 17.7192737,38.4828453 C17.8982374,38.1653499 18.2357618,37.9703618 18.6002047,37.9739308 C18.9646475,37.9774998 19.2982885,38.1790606 19.471,38.5 C21.4352479,41.9060686 25.0681337,44.0047148 29,44.0047148 C32.9318663,44.0047148 36.5647521,41.9060686 38.529,38.5 C38.7017115,38.1790606 39.0353525,37.9774998 39.3997953,37.9739308 C39.7642382,37.9703618 40.1017626,38.1653499 40.2807263,38.4828453 C40.45969,38.8003407 40.4517488,39.1900585 40.26,39.5 Z M41.5,30 C39.5670034,30 38,28.4329966 38,26.5 C38,24.5670034 39.5670034,23 41.5,23 C43.4329966,23 45,24.5670034 45,26.5 C45,28.4329966 43.4329966,30 41.5,30 Z",
    id: "Shape",
    fill: "#82EDDD",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.4f4b85e8507ee298bcc5400254269368.svg";
export { ForwardRef as ReactComponent };